import { DomainType, CohortCharacteristicsResultType } from '@verantos-dev/types-cohorts';

/**
 * Maps domain types to their corresponding API domain strings
 */
export const mapDomainToApiDomain = (
  domain: DomainType,
  format: 'lowercase' | 'capitalized' = 'capitalized'
): string => {
  const domainMap: Record<DomainType, { lowercase: string; capitalized: string }> = {
    [CohortCharacteristicsResultType.CC_CONDITION]: {
      lowercase: 'condition',
      capitalized: 'Condition',
    },
    [CohortCharacteristicsResultType.CC_DRUG]: { lowercase: 'drug', capitalized: 'Drug' },
    [CohortCharacteristicsResultType.CC_PROCEDURE]: {
      lowercase: 'procedure',
      capitalized: 'Procedure',
    },
    [CohortCharacteristicsResultType.CC_MEASUREMENT]: {
      lowercase: 'measurement',
      capitalized: 'Measurement',
    },
    [CohortCharacteristicsResultType.CC_OBSERVATION]: {
      lowercase: 'observation',
      capitalized: 'Observation',
    },
    [CohortCharacteristicsResultType.CC_VISIT]: { lowercase: 'visit', capitalized: 'Visit' },
  };

  const mapping = domainMap[domain];
  if (!mapping) {
    return format === 'lowercase' ? 'condition' : 'Condition';
  }

  return mapping[format];
};
